import {
  CyanGoalUnderstandingEngine,
  type RawOwnerGoalInput,
} from "./goalUnderstanding";

import { CyanPlanDecompositionEngine } from "./planDecomposition";

import { CyanGoalOrchestrator } from "./goalOrchestrator";

import type { CyanGoalPlan } from "./types";

export interface GoalIdFactory {
  createGoalId(): string;
}

export class CyanGoalPlanningService {
  constructor(
    private readonly ids: GoalIdFactory,

    private readonly understanding = new CyanGoalUnderstandingEngine(),

    private readonly decomposition = new CyanPlanDecompositionEngine(),

    private readonly orchestrator = new CyanGoalOrchestrator(),
  ) {}

  createPlan(input: RawOwnerGoalInput): CyanGoalPlan {
    const understanding = this.understanding.understand(input);

    const goal = this.understanding.createGoal(
      this.ids.createGoalId(),
      understanding,
    );

    if (understanding.requiresClarification) {
      return this.orchestrator.createPlan({
        goal,
        proposedSteps: [],
      });
    }

    const steps = this.decomposition.decompose(goal);

    return this.orchestrator.createPlan({
      goal,
      proposedSteps: steps,
    });
  }
}
